module.exports = __webpack_public_path__ + "img/icon-question.13b016c2.png";